export default "data:image/jpeg;base64,"